import FieldType from "@/utils/constants/FieldType.ts";
import ClientCache from "@/utils/login/ClientCache.ts";
import {ColDef} from "ag-grid-community";
import Translator from "@/utils/common/Translator.ts";
import ColumnFiltrationServerSideFactory from "@/utils/UIConstants/ColumnFiltrationServerSideFactory.ts";
import {ExtraDisplayColumnMethodOptions} from "@/utils/common/ListViewUtils.ts";
import AGGridUtils from "@/utils/UIConstants/AGGridUtils.ts";
import SearcherScreenLayout = namaTypes.SearcherScreenLayout;
import ListScreenLayout = namaTypes.ListScreenLayout;

export default abstract class AGGridColumn {
  protected column: namaTypes.ListScreenColumn;
  protected entityType: string;

  protected constructor(column: namaTypes.ListScreenColumn, entityType: string) {
    this.column = column;
    this.entityType = entityType;
  }

  get metaData() {
    return this.column.metaData;
  }

  abstract createColDef(extraOptions: ExtraDisplayColumnMethodOptions): ColDef;

  static defaultColDef(column: namaTypes.ListScreenColumn, entityType: string, layout?: (SearcherScreenLayout & ListScreenLayout) | undefined): ColDef {
    let filterData = ColumnFiltrationServerSideFactory.fetchFilterData(column, entityType, layout);
    return {
      field: column.id!,
      cellClass: AGGridUtils.excelStringStyleId,
      colId: column.id!,
      headerName: Translator.translateTitledId(entityType, column),
      hide: !column.displayed,
      filter: filterData?.filter,
      filterParams: filterData?.filterParams,
    }
  }

  static getFieldSpecs(metaData: any, entityType: string): namaTypes.DTOFieldSpecs | null | undefined {
    if (!metaData)
      return null;
    if ((metaData as namaTypes.FieldMetaData).fieldSpecs)
      return (metaData as namaTypes.FieldMetaData).fieldSpecs;
    return this.defaultSpecs(metaData, entityType)
  }

  static defaultSpecs(metaData: namaTypes.BasicFieldMetaData, entityType: string): namaTypes.DTOFieldSpecs | null {
    if (metaData.fieldType == FieldType.Decimal) {
      return {
        decimalPlaces: ClientCache.getDefaultDisplayFractionalDecimalPlaces(),
        format: ClientCache.getFieldDisplayMask(entityType, metaData.fieldId!)
      };
    }
    return null;
  }
}
